import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAllergies } from 'apiServices/reducer/dialogApiService';  
import CustomSuccessModal from '../../../components/CustomSuccessModal';
import { showPmrDeleteConfirm } from '../../../utils/swalUtils';

    const ManageAllergies = ({ show, onHide, allergiesList, refreshAllergies, onAllergyDelete, userId  }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const dispatch = useDispatch();
    const token = useSelector((state) => state.apiService?.token);
    const [localAllergies, setLocalAllergies] = useState(allergiesList);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const allergyCountBeforeDelete = useRef(0);
    useEffect(() => {
        setLocalAllergies(allergiesList);
    }, [allergiesList]);

    const handleDelete = async (allergyId) => {
        if (isDeleting) return;
        allergyCountBeforeDelete.current = localAllergies.length; // <--- Track before delete
        showPmrDeleteConfirm({
            message: 'You want to delete this allergy? This action cannot be undone.',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setIsDeleting(true);
                    const payload = { AllergyID: allergyId, userId, token };
                    const response = await dispatch(deleteAllergies(payload)).unwrap();
                    setSuccessMessage('Allergy deleted successfully!');
                    setShowSuccessModal(true);
                    setLocalAllergies(prev => prev.filter(a => a.allergy_id !== allergyId));
                    if (onAllergyDelete) onAllergyDelete(allergyId);
                    refreshAllergies();
                } catch (error) { 
                } finally {
                    setIsDeleting(false);
                }
            }
        });
    }; 

    const handleSuccessModalClose = () => {
        setShowSuccessModal(false);
        setSuccessMessage('');
        // If there was only one allergy before deletion, close the Manage Allergies modal
        if (allergyCountBeforeDelete.current === 1) {
            onHide();
        }
    };
    return (
        <Modal show={show} onHide={onHide} centered dialogClassName="wider-modal" backdrop="static" keyboard={false}>
            <Modal.Header closeButton className='modal-header-bg'>
                <Modal.Title className="modal-title-custom text-capitalize">Manage Allergies</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {localAllergies.length > 0 ? (
                    localAllergies.map((allergy) => (
                        <div key={allergy.allergy_id} className="d-flex justify-content-between align-items-center mb-3">
                            <span>
                                <strong>{allergy.allergy_name || 'N/A'}</strong> - {allergy.reactions || 'N/A'}
                            </span>
                            <button 
                                className="btn btn-link p-0"
                                onClick={() => handleDelete(allergy.allergy_id)}
                                disabled={isDeleting}
                                aria-label="Delete allergy"
                            >
                                <FaTrash className="text-danger" style={{ fontSize: 20 }} />
                            </button>
                        </div>
                    ))
                ) : (
                    <p className="text-muted">No allergies available.</p>
                )}
            </Modal.Body>

            {/* <Modal.Footer className='modal-header-bg'>
                <Button  style={{backgroundColor: '#007bff', borderColor: '#007bff'}} onClick={onHide} disabled={isDeleting}>
                    Close
                </Button>
            </Modal.Footer> */}
             <Modal.Footer className='modal-header-bg'>
                <Button variant="danger" className='text-capitalize' onClick={onHide} disabled={isDeleting}>Close</Button>
            </Modal.Footer> 
            <CustomSuccessModal
                show={showSuccessModal}
                onHide={handleSuccessModalClose}
                message={successMessage}
            />
        </Modal>
    );
};

export default ManageAllergies;